import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./services/queryClient";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import GalleryPage from "./pages/GalleryPage";
import ThemePage from "./pages/ThemePage";
import BrandKitPage from "./pages/BrandKitPage";
import DownloadPage from "./pages/DownloadPage";
import PrivacyPage from "./pages/PrivacyPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import TerminiCondizioniPage from "./pages/TerminiCondizioniPage";
import ContattiLegaliPage from "./pages/ContattiLegaliPage";
import BooksPage from "./pages/BooksPage";
import BookReaderPage from "./pages/BookReaderPage";
import SearchPage from "./pages/SearchPage";
import PostersPage from "./pages/PostersPage";
import PosterDetailPage from "./pages/PosterDetailPage";
import GamesListPage from "./pages/GamesListPage";
import GameDetailPage from "./pages/GameDetailPage";
import BolleMagicheGame from "./pages/BolleMagicheGame";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminPosters from "./pages/admin/AdminPosters";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminIllustrations from "./pages/admin/AdminIllustrations";
import AdminGenerator from "./pages/admin/AdminGenerator";
import AdminThemes from "./pages/admin/AdminThemes";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminBooks from "./pages/admin/AdminBooks";
import AdminBundles from "./pages/admin/AdminBundles";
import AdminGames from "./pages/admin/AdminGames";
import AdminLevelBackgrounds from "./pages/admin/AdminLevelBackgrounds";
import AdminSceneEditor from "./pages/admin/AdminSceneEditor";
import AdminLogin from "./pages/admin/AdminLogin";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/galleria" element={<GalleryPage />} />
            <Route path="/galleria/:themeId" element={<ThemePage />} />
            <Route path="/libri" element={<BooksPage />} />
            <Route path="/libri/:bookId" element={<BookReaderPage />} />
            <Route path="/cerca" element={<SearchPage />} />
            <Route path="/download" element={<DownloadPage />} />
            <Route path="/poster" element={<PostersPage />} />
            <Route path="/poster/:posterId" element={<PosterDetailPage />} />

            {/* Games Routes */}
            <Route path="/giochi" element={<GamesListPage />} />
            <Route path="/giochi/:slug" element={<GameDetailPage />} />
            <Route path="/giochi/bolle-magiche/play" element={<BolleMagicheGame />} />

            {/* Redirect old brand-kit URL to home */}
            <Route path="/brand-kit" element={<Navigate to="/" replace />} />

            {/* Legal Pages */}
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="/termini-condizioni" element={<TerminiCondizioniPage />} />
            <Route path="/contatti-legali" element={<ContattiLegaliPage />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="illustrations" element={<AdminIllustrations />} />
              <Route path="themes" element={<AdminThemes />} />
              <Route path="generator" element={<AdminGenerator />} />
              <Route path="books" element={<AdminBooks />} />
              <Route path="books/:bookId/scenes" element={<AdminSceneEditor />} />
              <Route path="posters" element={<AdminPosters />} />
              <Route path="bundles" element={<AdminBundles />} />
              <Route path="games" element={<AdminGames />} />
              <Route path="level-backgrounds" element={<AdminLevelBackgrounds />} />
              <Route path="brand-kit" element={<BrandKitPage />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
        <CookieBanner />
      </div>
    </QueryClientProvider>
  );
}

export default App;
